import { WatchQueryFetchPolicy } from '@apollo/client/core/watchQueryOptions'
import { useQuery } from '@apollo/client/react/hooks/useQuery'
import { stores } from '@stores'
import { GET_BUYING_SESSION } from '.'
import CLIENT_ASSORTMENTS from './clientAssortment'
import GET_ALLOTMENT from './Allotment'
import DOOR_ASSORTMENTS from './doorAssortment'
import { useState, useEffect } from 'react'
import { config } from '@config'
import { storage } from '@services/storageService'
import { HttpService } from '@services/HttpService'

export const useClientAssortments = () => {
  const {
    nav: {
      queryParams: { buyingSession }
    }
  } = stores
  const { data, loading, error } = useQuery(CLIENT_ASSORTMENTS, {
    skip: !buyingSession,
    variables: {
      buyingSessionId: buyingSession
    },
    fetchPolicy: 'cache-and-network'
  })
  return {
    items: data?.findVIPClientAssortment?.Items,
    loading,
    error
  }
}

export const useBuyingSession = (
  buyingSession: string,
  fetchPolicy: WatchQueryFetchPolicy = 'cache-first'
) => {
  return useQuery(GET_BUYING_SESSION, {
    skip: !buyingSession,
    variables: {
      id: buyingSession
    },
    fetchPolicy
  })
}

export const useDoorAssortments = () => {
  const {
    nav: {
      queryParams: { buyingSession }
    }
  } = stores
  const { data, loading, error } = useQuery(DOOR_ASSORTMENTS, {
    skip: !buyingSession,
    variables: {
      buyingSessionId: buyingSession
    },
    fetchPolicy: 'cache-and-network'
  })
  return { items: data?.findVIPDoorAssortment?.Items, loading, error }
}

export const useAllotments = ({
  activityId,
  genderId
}: {
  activityId?: string
  genderId?: string
} = {}) => {
  const {
    nav: {
      queryParams: { buyingSession }
    }
  } = stores
  const { data, loading, error } = useQuery(GET_ALLOTMENT, {
    skip: !buyingSession,
    variables: {
      buyingSessionId: buyingSession,
      ...(activityId ? { activityId } : {}),
      ...(genderId ? { genderId } : {})
    },
    fetchPolicy: 'cache-and-network'
  })
  return { items: data?.findVIPAllotment?.Items, loading, error }
}

export const useRetailAllotments = criteria => {
  const httpService = new HttpService()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState(null)
  const { activityId, genderId, buyingSessionGroupId } = criteria

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        let params = []
        Object.entries(criteria).forEach(([key, value]) => {
          params.push(`${key}=${value}`)
        })
        const url = `${
          config.buyingBoardServiceRestEndpoint
        }core/allotment/byCriteria/?${params.join('&')}`
        const accessToken: string = storage.getItem('access_token')

        const response = await httpService
          .get(url, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then(response => response?.data)
          .then(data =>
            data?.map(allot => ({
              Id: allot.id,
              Cluster: {
                Id: allot.cluster.id,
                Name: allot?.cluster?.name
              },
              ClusterGroup: {
                Id: allot.clusterGroup.id,
                Name: allot?.clusterGroup?.name
              },
              Activity: {
                Id: allot.activity.id,
                Name: allot?.activity?.name
              },
              Gender: {
                Id: allot.gender.id,
                Name: allot?.gender?.name
              },
              BuyingSessionGroup: {
                Id: allot.buyingSessionGroupId
              },
              door: {
                Id: allot.door.id,
                Name: allot.door.name
              },
              client: {
                Id: allot.client.id,
                Name: allot.client.name
              }
            }))
          )

        setData(response)

        setLoading(false)
      } catch (error) {
        setError(error)
        setLoading(false)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId, genderId, buyingSessionGroupId])
  return { data, loading, error }
}

export const useClusterGroups = (channel, isAssortmentSourceCluster) => {
  const httpService = new HttpService()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const url = `${config.buyingBoardServiceRestEndpoint}core/cluster-group?channelId=${channel}`
        const accessToken: string = storage.getItem('access_token')

        const response = await httpService
          .get(url, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then(response => response?.data)

        setData(response)

        setLoading(false)
      } catch (error) {
        setError(error)
        setLoading(false)
      }
    }
    if (!isAssortmentSourceCluster) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel])
  return { data, loading, error }
}
